export default {
  path: "/LearningModule",
  name: "Learning Module",
  htmlContent: "learning_module.html",
  headings: [],
};
